import { render, staticRenderFns } from "./ShopAtWorkSubscription.vue?vue&type=template&id=38a4947e"
import script from "./ShopAtWorkSubscription.vue?vue&type=script&lang=js"
export * from "./ShopAtWorkSubscription.vue?vue&type=script&lang=js"
import style0 from "./ShopAtWorkSubscription.vue?vue&type=style&index=0&id=38a4947e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports